import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface BookingUsageProps {
  used: number;
  max: number;
}

export function BookingUsage({ used, max }: Readonly<BookingUsageProps>): React.JSX.Element {
  const { t } = useTranslation();
  const isExhausted: boolean = used >= max;
  const usedPercent: number = max === 0 ? 100 : Math.min(100, (used / max) * 100);
  const usageCountClassName: string = cn(
    'font-semibold',
    isExhausted ? 'text-primary' : 'text-foreground'
  );

  return (
    <div className="flex w-28 flex-col gap-1.5">
      <span className="whitespace-nowrap text-muted-foreground">
        <span className={usageCountClassName}>
          {used} / {max}
        </span>{' '}
        {t('users.freeBookingsUsed')}
      </span>
      <div aria-hidden="true" className="h-1 overflow-hidden rounded-full bg-muted">
        <div
          className={cn('h-full rounded-full', 'bg-primary')}
          style={{ width: `${usedPercent}%` }}
        />
      </div>
    </div>
  );
}
